import PermissionGuard from 'components/Global/PermissionGuard';
import OpeningBalanceImport from 'components/Settings/PayrollSettings/OpeningBalance';


export const OpeningBalance = () => {
	return (
		<PermissionGuard permission="Allow_Opening_Balance">
			<OpeningBalanceImport />
		</PermissionGuard>
	);
};
